<div class="usb-accordion" [class.animated]="config.animated"
     [ngStyle]="{'padding-left': paddingAccordion('left'),
                 'padding-right': paddingAccordion('right')}">
  <div *ngFor="let item of items; let i = index"
       class="accordion-item"
       [class.expanded]="isOpen(item.id)"
       [class.disabled]="item.disabled"
       [class.border-top]="config.borderTop"

       [ngClass]="item.customClass">

    <div class="accordion-header"
         [attr.aria-expanded]="isOpen(item.id)"
         [attr.aria-controls]="'accordion-content-' + item.id"
         (click)="toggleItem(item, i)"
         (keydown.enter)="toggleItem(item, i)"
         (keydown.space)="toggleItem(item, i); $event.preventDefault()"
         tabindex="0"
         role="button">

      <!-- ✅ Simplificar las expresiones en el template -->
      <div class="d-flex align-items-center">
        <!-- <img *ngIf="item.icon" [src]="item.icon" class="accordion-icon-img" alt=""> -->
        <span class="accordion-title">{{ item.title }}</span>
        <span *ngIf="item.badge" class="accordion-badge">{{ item.badge }}</span>
      </div>

      <span *ngIf="config.showArrows" class="accordion-icon" [class.rotated]="isOpen(item.id)"><i class="bi bi-caret-down-fill" style="font-size: .75rem"></i></span>
    </div>


    <div class="accordion-content-wrapper" *ngIf="isOpen(item.id)">
      <div class="accordion-content py-3 pr-3"
           [attr.aria-hidden]="!isOpen(item.id)"
           [attr.id]="'accordion-content-' + item.id">

        <ng-container *ngIf="customContentTemplate; else defaultContent">
          <ng-container *ngTemplateOutlet="customContentTemplate; context: { $implicit: item, index: i }"></ng-container>
        </ng-container>

        <ng-template #defaultContent>
          <p class="mb-0">{{ item.data?.description || 'Sin contenido' }}</p>
        </ng-template>

      </div>
    </div>
  </div>
</div>
